import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'iss-drawer-footer',
  standalone: true,
  templateUrl: './drawer-footer.component.html',
  styleUrls: [ './drawer-footer.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerFooterComponent {}
